import React, {useState} from 'react';
import {Popover, Text} from '@mantine/core';

const options = [
  {label: 'Sim', value: true},
  {label: 'Não', value: false},
];

const PaidBillingSelect: React.FC<BillingProps> = ({id, paid}) => {
  const [opened, setOpened] = useState(false);
  const {accessControl} = useAccessControls();
  const [searchText, setSearch] = useState('');
  const availableOptions = options.filter(
    (option) =>
      option.label.toLocaleLowerCase().search(searchText.toLocaleLowerCase()) >=
      0,
  );
  const {mutate, isLoading} = usePayBilling(id!);

  return (
    <Popover
      key={id}
      withinPortal
      trapFocus={false}
      opened={opened}
      onClose={() => setOpened(false)}
      zIndex={1001}
      keepMounted
      styles={{dropdown: {padding: 0}}}>
      <Popover.Target>
        <div
          style={{cursor: 'pointer'}}
          onClick={() => {
            if (!accessControl?.companyId) setOpened(true);
          }}>
          <Row style={{alignItems: 'start', gap: 10}}>
            <MdPaid size={20} />
            <Column>
              <Text>Pago?</Text>
              {isLoading && <Loading />}
              {!isLoading && <RegularText>{paid ? 'Sim' : 'Não'}</RegularText>}
            </Column>
          </Row>
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <Container>
          <Input
            placeholder="Pesquisar"
            autoFocus
            onChange={(e) => setSearch(e.target.value)}
          />
          <OptionList>
            {availableOptions.map((option, index) => (
              <Option
                className="ignore"
                key={index}
                onClick={() => {
                  mutate({paid: option.value});
                  setOpened(false);
                }}>
                {option?.label}
              </Option>
            ))}
          </OptionList>
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default PaidBillingSelect;

import styled from 'styled-components';
import Loading from 'shared/migration-components/loading';
import {BillingProps} from '../types';
import {MdPaid} from 'react-icons/md';
import usePayBilling from '../hooks/use-pay-billing';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

const Container = styled.div`
  min-width: 350px;
  overflow: hidden;
  background-color: white;
  max-height: 400px;
  padding: 15px;
  overflow-y: auto;
  border-radius: 6px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.softGray};
  background-color: ${(props) => props.theme.colors.softGray};
  border: 2px solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  margin-bottom: 10px;

  &:focus {
    background-color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.primary};
    outline: none;
  }
`;

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

const Option = styled.div`
  height: 40px;
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.darkGray};
  justify-content: flex-start;

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${(props) => props.theme.colors.primaryLight};
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Row = styled.div`
  display: flex;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const RegularText = styled.text`
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  margin-top: -5px;
`;
